  let quality = 'high'; // default fallback
    
      if (navigator.connection && navigator.connection.downlink) {
        const speed = navigator.connection.downlink;
        if (speed >= 7) {
          quality = 'high';
        } else if (speed >= 3) {
          quality = 'medium';
        } else if (speed >= 1) {
          quality = 'low';
        } else {
          quality = 'none';
        }
      }
    
      const videoContainer = document.getElementById('video-container');
    
      if (quality !== 'none') {
        const video = document.createElement('video');
        video.className = 'landing-page-video';
        video.playsInline = true;
        video.disableRemotePlayback = true;
        video.disablePictureInPicture = true;
        video.muted = true;
        video.autoplay = true;
        video.loop = true;
    
        const source = document.createElement('source');
    
        // Replace these URLs with your actual video sources
        if (quality === 'high') {
          source.src = 'https://cdn.shopify.com/videos/c/o/v/935d985ed81449719718d1ab1d4d611a.mov';
        } else if (quality === 'medium') {
          source.src = 'https://cdn.shopify.com/videos/c/o/v/935d985ed81449719718d1ab1d4d611a.mov'; // Replace with actual medium quality video
        } else {
          source.src = 'https://cdn.shopify.com/videos/c/o/v/935d985ed81449719718d1ab1d4d611a.mov'; // Replace with actual low quality video
        }
    
        video.appendChild(source);
        videoContainer.appendChild(video);
      } else {
        // Optional: black screen or image placeholder
        videoContainer.style.backgroundColor = 'black';
        videoContainer.style.width = '100%';
        videoContainer.style.height = '100vh'; // or any height that fits your layout
      }